import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function ES_Mobile_view_faq_comp() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className='pb-4'>
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography className='fs-6'>What is an embedded system?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          An embedded system is a computer system designed to perform specific tasks within a larger system. It is typically embedded into a device or product to control its operation and perform dedicated functions.    
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>What is firmware in embedded systems?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Firmware refers to software that is stored in non-volatile memory (such as ROM or flash memory) and is responsible for controlling the hardware of an embedded system. It provides the low-level control necessary to perform specific tasks and interact with peripherals.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>What are some tools used in embedded system development?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Tools commonly used in embedded system development include integrated development environments (IDEs) such as Keil µVision, Eclipse, and Visual Studio, as well as debugging tools, compilers, simulators, and hardware emulators.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
    </div>
  );
}
